module.exports = __webpack_public_path__ + "img/logo-s.4faf9a9b.png";